/**
 * 12×12 info circle — smaller variant of InfoIcon for inline use next to
 * version rows, tooltips, etc. Uses currentColor for both stroke and fill.
 */
export function InfoIconSmall() {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
      <circle cx="6" cy="6" r="5" stroke="currentColor" strokeWidth="1.2" />
      <path
        d="M6 5.5V8.5"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <circle cx="6" cy="3.75" r="0.6" fill="currentColor" />
    </svg>
  );
}
